import { Seg } from "@kitchen/ui";
import { useState } from "react";
import { InvoicesTab } from "./invoices.js";
import { PaymentsTab } from "./payments.js";
import { RePricingTab } from "./repricing.js";
import { StatementTab } from "./statement.js";

type FinanceTab = "invoices" | "payments" | "statement" | "repricing";

export function FinancePage() {
  const [tab, setTab] = useState<FinanceTab>("invoices");

  return (
    <div className="stack" style={{ gap: "var(--s4)" }}>
      <div className="row wrap" style={{ alignItems: "center" }}>
        <Seg<FinanceTab>
          label="بخش مدیریت مالی و حسابداری"
          value={tab}
          onChange={setTab}
          options={[
            { value: "invoices", label: "فاکتورها" },
            { value: "payments", label: "دریافت‌ها و چک‌ها" },
            { value: "statement", label: "حساب و صورتحساب سازمان" },
            { value: "repricing", label: "پیش‌نمایش بازقیمت‌گذاری" },
          ]}
        />
      </div>

      {tab === "invoices" && <InvoicesTab />}
      {tab === "payments" && <PaymentsTab />}
      {tab === "statement" && <StatementTab />}
      {tab === "repricing" && <RePricingTab />}
    </div>
  );
}

export * from "./invoices.js";
export * from "./payments.js";
export * from "./statement.js";
export * from "./repricing.js";
export * from "./print.js";
